import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../api';
import api from '../../api/endpoints';

function* getSwagger() {
  try {
    const { data } = yield call(fetch, { api: api.swagger, pub: true });

    yield put(actions.getSwaggerDone({
      data: data.components.schemas,
      raw: data
    }));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getSwaggerFailed,
      endpoint: api.swagger.url
    });
  }
}

export const getSwaggerSaga = takeEvery(types.GET_SWAGGER_REQUEST, getSwagger);